<div class="contact-profile-wrapper">
    <!-- Contact Profile -->
    <div class="contact-profile">
        <div class="contact-profile__picture">
            <div class="user-avatar">
                <span class="user-avatar__img">
                    {{campaignService.lead?.CustomerInfo?.FirstName.at(0) ??
                    '-'}}{{campaignService.lead?.CustomerInfo?.LastName.at(0) ??
                    '-'}}
                </span>
                <i class="user-avatar__status-icon"></i>
            </div>
        </div>

        <div class="contact-profile__name">
            <h5>{{campaignService.lead?.CustomerInfo?.FirstName ?? '---'}} {{campaignService.lead?.CustomerInfo?.LastName
                ??
                '---'}}</h5>
            <div class="pills-wrapper">
                <div class="pills">
                    <div class="pills__content">
                        <span>{{telephonyState.btn}}</span>
                        <!-- <span class="bg-primary">Landline</span> -->

                        <!-- <div class="icons-group-wrapper">
                            <div class="icons-group">
                                <div class="icons-group__icons">
                                    <i class="fa-light fa-copy"></i>
                                    <i class="fa-light fa-pen-to-square"></i>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Profile Numbers
            use card-panel--collapsed to collapse the card - example below: -->
<div class="card-panel profile-number" [ngClass]="{ 'card-panel--collapsed': cardCollapseState.ProfileNumbers }"
    [@smoothCollapse]="cardCollapseState.ProfileNumbers?'initial':'final'">
    <div class="card-panel__title" data-toggle="profile-num" (click)="onCollapse('ProfileNumbers')">
        <h4>All Numbers</h4>
        <i class="fa-light fa-angle-down"></i>
    </div>

    <div class="card-panel__details">
        <div class="pills push-top-2">
            <div class="pills__content">
                <span>Home</span>
                <!-- <span class="bg-primary">Landline</span>
                <span class="bg-secondary">Primary</span> -->

                <!-- <div class="icons-group-wrapper icons-group-wrapper-profile">
                    <div class="icons-group">
                        <div class="icons-group__icons">
                            <i class="fa-light fa-pen-to-square"></i>
                            <i class="fa-light fa-ellipsis-vertical"></i>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <h5>{{telephonyState.btn}}</h5>
    </div>

    <div class="card-panel__details">
        <div class="pills push-top-2">
            <div class="pills__content">
                <span>Callback</span>
                <!-- <span class="bg-teritary">Wirless</span> -->

                <!-- <div class="icons-group-wrapper icons-group-wrapper-profile">
                    <div class="icons-group">
                        <div class="icons-group__icons">
                            <i class="fa-light fa-pen-to-square"></i>
                            <i class="fa-light fa-ellipsis-vertical"></i>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <h5>{{telephonyState.btn}}</h5>
    </div>

    <!-- <div class="card-panel__action-btn">
                  <div class="chips chips--no-paddings">
                      <i class="fa-light fa-circle-plus chips__icon chips__icon--primary"></i>
                      <span class="chips__value chips__value--primary">Add number</span>
                  </div>
              </div> -->
</div>

<!-- Contact Info -->
<div class="card-panel id-about-this-contact" [ngClass]="{ 'card-panel--collapsed': cardCollapseState.ContactInfo }"
    [@smoothCollapse]="cardCollapseState.ContactInfo?'initial':'final'">
    <div class="card-panel__title" (click)="onCollapse('ContactInfo')">
        <h4>About this Contact</h4>
        <i class="fa-light fa-angle-down"></i>
    </div>
    <div class="card-panel__details">
        <!-- Name Value Pair -->
        <div class="name-value-pair">
            <i class="name-value-pair__icon fa-light fa-square-user"></i>
            <span class="name-value-pair__label">Full Name</span>
            <p class="name-value-pair__value has-ellipsis">{{campaignService.lead?.CustomerInfo?.FirstName ?? '--'}}
                {{campaignService.lead?.CustomerInfo?.LastName ?? '--'}} </p>
        </div>
        <!-- <div class="name-value-pair">
                      <i class="name-value-pair__icon fa-light fa-building"></i>
                      <span class="name-value-pair__label">Owner</span>
                      <p class="name-value-pair__value has-ellipsis">Hubspot Intergration</p>
                  </div> -->
        
        <div class="name-value-pair">
            <i class="name-value-pair__icon fa-light fa-envelope"></i>
            <span class="name-value-pair__label">Email</span>
            <p class="name-value-pair__value has-ellipsis">{{campaignService.lead?.CustomerInfo?.Email ?? '--'}}</p>
        </div>
        
        <div class="name-value-pair">
            <i class="name-value-pair__icon fa-light fa-city"></i>
            <span class="name-value-pair__label">City & State</span>
            <p class="name-value-pair__value has-ellipsis">{{campaignService.lead?.CustomerInfo?.City ?? '--'}},
                {{campaignService.lead?.CustomerInfo?.State ?? '--'}}</p>
        </div>
        
        <div class="name-value-pair">
            <i class="name-value-pair__icon fa-light fa-location-dot"></i>
            <span class="name-value-pair__label">Address</span>
            <p class="name-value-pair__value has-ellipsis">{{campaignService.lead?.CustomerInfo?.Address ?? '--'}}</p>
        </div>
    </div>
</div>

<!-- Call Info -->
<div class="card-panel" [ngClass]="{ 'card-panel--collapsed': cardCollapseState.CallInfo }"
    [@smoothCollapse]="cardCollapseState.CallInfo?'initial':'final'">
    <div class="card-panel__title" (click)="onCollapse('CallInfo')">
        <h4>Call History</h4>
        <i class="fa-light fa-angle-down"></i>
    </div>
    <div class="card-panel__details">
        <div class="call-info-wrapper">
            <!-- <div class="call-info">
                <h6 class="call-info__title">Total Calls</h6>
                <div class="call-info__details">
                    <div class="chips-call-info-wrapper">
                        <div class="chips chips--no-paddings">
                            <i class="fa-light fa-phone chips__icon chips__icon--secondary"></i>
                            <span
                                class="chips__value chips__value--secondary">{{campaignService.lead?.TotalCalls - 1}}</span>
                        </div>
                    </div>
                </div>
            </div> -->
            <br/>
            <div class="call-info">
                <h6 class="call-info__title">Total Call Time</h6>
                <div class="call-info__details">
                    <div class="chips-call-info-wrapper">
                        <div class="chips chips--no-paddings">
                            <i class="fa-light fa-phone chips__icon chips__icon--secondary"></i>
                            <span
                                class="chips__value chips__value--secondary">{{campaignService.lead?.TotalCallMinutes}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div class="call-info">
                <h6 class="call-info__title">Last Call Time</h6>
                <div class="call-info__details">
                    <div class="chips-call-info-wrapper">
                        <div class="chips chips--no-paddings">
                            <i class="fa-light fa-phone chips__icon chips__icon--secondary"></i>
                            <span
                                class="chips__value chips__value--secondary">{{campaignService.lead?.LastCallMinutes}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div class="call-info">
                <h6 class="call-info__title">Last Call Start Time</h6>
                <div class="call-info__details">

                    <div class="chips-call-info-wrapper">
                        <div class="chips chips--no-paddings">
                            <i class="fa-light fa-calendar chips__icon chips__icon--secondary"></i>
                            <span
                                class="chips__value chips__value--secondary">{{campaignService.lastCall?.StartTime}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div class="call-info">
                <h6 class="call-info__title">Last Call End Time</h6>
                <div class="call-info__details">

                    <div class="chips-call-info-wrapper">
                        <div class="chips chips--no-paddings">
                            <i class="fa-light fa-calendar chips__icon chips__icon--secondary"></i>
                            <span
                                class="chips__value chips__value--secondary">{{campaignService.lastCall?.EndTime}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <br/>        
        </div>
    </div>
</div>

<!-- Contact Note -->
<div class="card-panel" [ngClass]="{ 'card-panel--collapsed': cardCollapseState.ContactNote }"
    [@smoothCollapse]="cardCollapseState.ContactNote?'initial':'final'">
    <div class="card-panel__title" (click)="onCollapse('ContactNote')">
        <h4>Notes</h4>
        <i class="fa-light fa-angle-down"></i>
        <!-- <a >Add Notes</a> -->
    </div>
    <div class="contact-note__detials">
        <p>{{campaignService.lastCall?.Note}}</p>
    </div>
</div>